import styled from 'styled-components';

export const IconStyle = styled.img<{ customWidth?: string; customHeight?: string }>`
  width: ${(props) => props.customWidth || '65px'};
  height: ${(props) => props.customHeight || '69px'};
`;
